import axiosInstance from 'apis/axiosInstance';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import CustomDayPopover from 'components/CustomDayPopover/CustomDayPopover';
import { renderToast } from 'components/Toast/Toast';
import useMatchMutate from 'hooks/useMatchMutate';
import { IService } from 'interfaces/services';
import ServiceScheduleException from 'interfaces/serviceScheduleException';
import moment from 'moment';
import EditScheduleModal from 'pages/RevampServicePage/MainSection/EditScheduleModal/EditScheduleModal';
import { FC, useState } from 'react';

interface ServiceRowThreeDotsOptionProps {
  day: ServiceScheduleException;
  service: IService;
  isShown: boolean;
}

const ServiceRowThreeDotsOption: FC<ServiceRowThreeDotsOptionProps> = ({
  day,
  service,
  isShown,
}) => {
  const [modal, setModal] = useState<'edit' | 'delete' | null>(null);
  const matchMutate = useMatchMutate();

  const handleDeleteCustomDay = async () => {
    const payload = {
      dates: [day.date],
    };
    try {
      await axiosInstance.delete(`/services/${service.id}/exceptions`, {
        data: payload,
      });
      await Promise.all([
        matchMutate(/\/services\/[\s\S]+\/exceptions[\s\S]+/, {
          revalidate: true,
        }),
        matchMutate(/\/services\/[\s\S]+\/custom-days[\s\S]+/, {
          revalidate: true,
        }),
      ]);
      renderToast({
        message: 'A custom day is successfully deleted',
        type: 'success',
      });
    } catch (error) {
      renderToast({
        message: 'Something went wrong. Please try again later.',
        type: 'error',
      });
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {modal === 'delete' && (
        <ConfirmationModal
          title={'Delete this custom day?'}
          description={`Are you sure you want to delete this custom day on ${moment(
            day.date,
            'YYYY-MM-DD'
          ).format(
            'MMMM DD, YYYY'
          )}? This will revert this day to regular hours.`}
          onClose={() => setModal(null)}
          onSubmit={handleDeleteCustomDay}
          submitBtnTitle="Yes, delete"
        />
      )}
      {modal === 'edit' && (
        <EditScheduleModal
          onClose={() => setModal(null)}
          service={service}
          selectedCellData={{
            shifts: day.shifts,
            date: day.date,
            day: day.day,
            isServiceClosed: day.shifts.some(
              (shift) => !shift.startTime && !shift.endTime
            ),
          }}
        />
      )}
      <CustomDayPopover isShown={isShown} setModal={setModal} />
    </div>
  );
};

export default ServiceRowThreeDotsOption;
